{
  "$id": "wealthlane://forms/job-title",
  "$schema": "wealthlane://schemas/form-model",
  "domain": "../job-title.domain.json",
  "properties": {
    "name": {
      "$ref": "module://job-title#properties/name",
      "required": true
    },
    "description": {
      "$ref": "module://job-title#properties/description"
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_JOB_TITLE",
      "refreshEntities": ["job-title"],
      "invalidateQueries": ["getCustomerTitleListWithPagination"]
    }
  },
  "modes": {
    "create": {
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "edit": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_JOB_TITLE_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "view": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_JOB_TITLE_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "viewPresentation": "disabled-inputs"
    }
  }
}
